/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAIDailyUsageViewModel } from "../types/TutorAIDailyUsageViewModel.ts";

export const tutorAIDailyUsageViewModelSchema = z.object({
  date: z.string().describe("Data no formato yyyy-MM-dd.").nullish(),
  tokensUsed: z.optional(
    z.number().int().describe("Total de tokens consumidos nessa data."),
  ),
}) as unknown as ToZod<TutorAIDailyUsageViewModel>;
